// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/true-altitude-in-spr.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/true-altitude-in-spr/true-altitude-in-spr.js';

mount([g0]);
